import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import ZomatoPayoutCalculator from '../../components/ZomatoPayoutCalculator';
import { adminAPI } from '../../services/api';

/**
 * Admin wrapper for the Tomato payout + real-profit calculator — for the team to
 * show a restaurant its REAL Tomato economics while pitching. Auto-loads each
 * restaurant's real Tomato markup & captured offers (competitor-intel).
 * (Restaurants have the same tool self-serve at /restaurant/tomato-calculator.)
 */
function ZomatoPayoutAdmin() {
  const [markups, setMarkups] = useState([]);
  useEffect(() => { adminAPI.ciMarkups().then((r) => setMarkups(r.data?.data || [])).catch(() => {}); }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8' }}>
      <Navbar />
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', margin: '0 0 4px' }}>Tomato payout &amp; real-profit calculator</h1>
        <p style={{ color: '#64748B', fontSize: 14, margin: '0 0 18px' }}>
          Pick a restaurant to auto-load its real Tomato markup &amp; offers, then see what it <b>actually receives</b> and
          whether it's <b>making a profit or selling at a loss</b> after food cost — plus how much more it'd keep on FoodWinc.
        </p>
        <ZomatoPayoutCalculator restaurantMarkups={markups} />
      </div>
    </div>
  );
}

export default ZomatoPayoutAdmin;
